import * as React from 'react';

import Container from 'components/Container';
import Row from 'components/Row';
import Text from 'components/Text';
import LinkConstants from 'constants/LinkConstants';
import OrganizationEngagementBanner from 'organizations/components/OrganizationEngagementBanner';
import { EngagementRating } from 'organizations/constants/EngagementRatings';
import {
  ADMIN_RECOMMENDATIONS,
} from 'organizations/constants/OrganizationEngagementViewCopy';

import OrganizationEngagementViewContainer from './OrganizationEngagementViewContainer';
import OrganizationEngagementViewHeading from './OrganizationEngagementViewHeading';
import OrganizationEngagementViewScreenshotFigures from './OrganizationEngagementViewScreenshotFigures';
import OrganizationEngagementViewSection from './OrganizationEngagementViewSection';

type Props = {
  eventKey: string;
  onShowRatingsModal: () => void;
  schoolRating?: EngagementRating | undefined;
  utmParams: string;
};

export default function OrganizationEngagementViewAdmins({
  eventKey,
  onShowRatingsModal,
  schoolRating,
  utmParams,
}: Props) {
  return (
    <OrganizationEngagementViewSection theme="dark" className="OrganizationEngagementViewAdmins">
      <Container>
        <Text align="center" element="div">
          <Row size="xxxlarge">
            <header>
              <Container size="small">
                <OrganizationEngagementViewHeading
                  subtext={
                    <React.Fragment>
                      62% of Remind-rostered schools are rated <strong>Engaged</strong>.
                    </React.Fragment>
                  }>
                  Activate engagement across every school in your district.
                </OrganizationEngagementViewHeading>
              </Container>
            </header>
          </Row>
          <Row size="xxxxxlarge">
            <OrganizationEngagementViewScreenshotFigures
              items={[
                {
                  alt: 'An example of a list of schools on Remind',
                  caption: 'Consolidate new and existing engagement on a single platform.',
                  image: require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewAdmins/screenshots/rostering.png'),
                  image2x: require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewAdmins/screenshots/rostering@2x.png'),
                },
                {
                  alt: 'Remind’s voice calling feature',
                  caption:
                    'Leverage effective communication channels for school and district notifications.',
                  image: require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewAdmins/screenshots/advanced-messaging.png'),
                  image2x: require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewAdmins/screenshots/advanced-messaging@2x.png'),
                },
              ]}
            />
          </Row>
          <Row>
            <OrganizationEngagementViewContainer size="small">
              <OrganizationEngagementBanner
                title="Tip for schools and districts"
                badgeAction={onShowRatingsModal}
                cta="Learn more about the Remind plan for schools and districts"
                rating={schoolRating}
                theme="dark"
                to={`${LinkConstants.ADMIN_UPGRADE}?${utmParams}&utm_content=tips`}
                eventKey={`${eventKey}.admins.cta.click`}>
                {schoolRating
                  ? ADMIN_RECOMMENDATIONS[schoolRating]
                  : 'Improve engagement at scale with a platform as easy to use for administrators and staff members as it is for students and parents.'}
              </OrganizationEngagementBanner>
            </OrganizationEngagementViewContainer>
          </Row>
        </Text>
      </Container>
    </OrganizationEngagementViewSection>
  );
}
